var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',{staticClass:"paymentWidgets",attrs:{"action":_vm.returnUrl,"data-brands":"VISA MASTER AMEX"}}),_vm._v(" "),_c('ErrorSnackbar',{model:{value:(_vm.showError),callback:function ($$v) {_vm.showError=$$v},expression:"showError"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }